import { createFileRoute } from '@tanstack/react-router'

import { SingleVerification } from '@/widgets/case-management/single-verification'

export const Route = createFileRoute('/_app/case-management/verifications/$id')({
  component: RouteComponent,
})

export const SingleVerificationRoute = Route

function RouteComponent() {
  const { id } = Route.useParams()

  return <SingleVerification id={id} />
}
